import React from 'react';
import PropTypes from 'prop-types';
import Time from '~shared/ui/Time/Time';
import Carousel from '~spa/Components/Carousel';
import { DATE_TIME_FORMAT_DD_MMM, DATE_TIME_FORMAT_HM } from '~shared/utils/constants';
import { getLocalizedDateFormat } from '~shared/utils/date-time';
import LoadingIndicator from '~spa/Components/LoadingIndicator';
import { isIndividualPage } from '~scenes/sport/horse-racing/utils';
import { getExtraEventData, getSportSlug } from '../../utils';
import {
    BB_RACING_WIDGET_SCHEDULE_CLASS,
    BB_RACING_WIDGET_RACE_TAB,
} from '../../constants';

const propTypes = {
    racingData: PropTypes.object,
    getRaceCard: PropTypes.func,
    source: PropTypes.string,
    displayType: PropTypes.string,
    onFeaturedPageTabSelected: PropTypes.func,
};

// &nbsp; because iPhone 8 doesn't like flex column-gap
const headlineIcon = <span className="schedule-tab__icon schedule-tab__icon-svg-headline">&nbsp;</span>;
const bogIcon = <span className="schedule-tab__icon schedule-tab__icon-svg-bog">&nbsp;</span>;
const ewPlusIcon = <span className="schedule-tab__icon schedule-tab__icon-text">EW+</span>;

class ScheduleTabs extends React.Component {
    // default for the carousel
    selectedItemIndex = 0;

    constructor(props) {
        super(props);
        this.onTabClick = this.onTabClick.bind(this);
    }

    getScheduleTabs() {
        const racingData = this.props.racingData;

        return racingData.display_order.map((eventId, index) => {
            const event = racingData.events[eventId];
            const isFeaturedTab = racingData.featured;
            const tournament = racingData.tournaments_details[event.details.tournament_id].name;

            const {
                isDefaultEvent, eachwayPlusAllowed, isBog, hasHeadline,
            } = getExtraEventData(racingData, eventId);

            if (isDefaultEvent) {
                this.selectedItemIndex = index;
            }

            const dateUtc = event.details.scheduled_start;
            let dateLabel = null;
            if (isFeaturedTab) {
                // &nbsp; because iPhone 8 doesn't like flex column-gap
                dateLabel =
                    <span>
                        <Time dateTime={dateUtc} format={getLocalizedDateFormat(DATE_TIME_FORMAT_DD_MMM)}/>
                        &nbsp;
                    </span>;
            }

            return (
                <div role="button" key={eventId} data-event-id={eventId} className="schedule-tab">
                    <div className="schedule-tab__datetime">
                        {dateLabel}
                        <span>
                            <Time dateTime={dateUtc} format={getLocalizedDateFormat(DATE_TIME_FORMAT_HM)}/>
                        </span>
                    </div>
                    <div className="schedule-tab__tournament">
                        {tournament}
                    </div>
                    <div className="schedule-tab__icons">
                        {eachwayPlusAllowed && ewPlusIcon}
                        {isBog && bogIcon}
                        {hasHeadline && headlineIcon}
                    </div>

                </div>
            );
        });
    }

    onTabClick (_index, e) {
        // user could click in between the tabs || on tab itself
        const eventId = e.target?.closest('[data-event-id]')?.dataset?.eventId
            || e.target?.querySelector('[data-event-id]')?.dataset?.eventId
            || false;
        if (eventId) {
            if (isIndividualPage(this.props.displayType)) {
                this.props.onFeaturedPageTabSelected(eventId);

                return;
            }

            this.props.getRaceCard(eventId);
        }
    }

    render() {
        if (!isIndividualPage(this.props.displayType) && this.props.racingData.isLoading) {
            return <LoadingIndicator />;
        }

        const scheduleTabs = this.getScheduleTabs();
        const sportSlug = getSportSlug(this.props.racingData.sports_details);

        const gtm = `${this.props.source};${sportSlug}-widget;${BB_RACING_WIDGET_RACE_TAB}`;

        return (
            <div data-spectate-product={gtm} className={BB_RACING_WIDGET_SCHEDULE_CLASS}>
                <Carousel
                    jsxItems={scheduleTabs}
                    selectedItemSlugOrId={this.selectedItemIndex}
                    onItemClick={this.onTabClick}
                />
            </div>
        );
    }
}

ScheduleTabs.propTypes = propTypes;

export default ScheduleTabs;
